import { FontWeight, Heading, Text } from '@lili/lili-frontend-common';
import { Trans, useTranslation } from 'react-i18next';

import { ReactComponent as FastestGrowingIcon } from '@Assets/awards/fastest-growing.svg';
import { ReactComponent as FastestGrowingIconMobile } from '@Assets/awards/fastest-growing-mobile.svg';
import { ReactComponent as BestAi } from '@Assets/awards/best-ai.svg';
import { ReactComponent as BestAiMobile } from '@Assets/awards/best-ai-mobile.svg';
import { ReactComponent as BestMobile } from '@Assets/awards/best-mobile.svg';
import { ReactComponent as BestMobileMobile } from '@Assets/awards/best-mobile-mobile.svg';
import { ReactComponent as BestSmbApp } from '@Assets/awards/best-smb-app.svg';
import { ReactComponent as BestSmbAppMobile } from '@Assets/awards/best-smb-app-mobile.svg';
import { ReactComponent as BestSmbBankMobile } from '@Assets/awards/best-smb-bank-mobile.svg';
import { ReactComponent as BestSmbBank } from '@Assets/awards/best-smb-bank.svg';
import { ReactComponent as BestSmbDigital } from '@Assets/awards/best-smb-digital.svg';
import { ReactComponent as BestSmbDigitalMobile } from '@Assets/awards/best-smb-digital-mobile.svg';
import { EmbeddedSupportDetails } from '@Components/supportDetails/EmbeddedSupportDetails';
import { WelcomeBonusChip } from '../WelcomeBonusChip';

export const ValueProposalWyoming = () => {
  const { t } = useTranslation();

  return (
    <div className='px-[16px] sm:px-[48px] pt-[24px] sm:pt-[250px] overflow-auto'>
      <div className='sm:min-h-[62dvh] mb-[56px] sm:mb-0 flex flex-col gap-[24px] sm:gap-[208px] items-center sm:justify-center'>
        <div className='flex flex-col items-center justify-center gap-[24px]'>
          <div className='hidden sm:block'>
            <WelcomeBonusChip />
          </div>
          <Heading.H4
            fontWeight={FontWeight.SEMIBOLD}
            className='max-w-[469px] w-full text-text-main-primary-inverse text-[22px] leading-[1.1] whitespace-pre-line text-center sm:text-left'>
            <Trans
              t={t}
              i18nKey='pages.homePasswordless.valueProposal.mainHeadline'
              components={{
                serif: (
                  <span className='font-sourceSansProSemiBold text-[24px] text-text-brand-highlight-orange' />
                ),
                orange: <span className='text-text-brand-highlight-orange' />,
              }}
            />
          </Heading.H4>
        </div>
        <DesktopAwardsSection />
        <MobileAwardsSection />
      </div>

      <div className='sm:hidden'>
        <EmbeddedSupportDetails shouldCenter />
      </div>
      <div className='flex flex-col'>
        <div className='flex flex-col gap-[4px] tab-landscape:bg-transparent mt-[8px]'>
          <ol
            className='list-decimal text-[10px] text-text-main-tertiary-inverse pl-[8px]'
            type='1'>
            <li>
              <Text.H14 className='text-text-main-tertiary-inverse'>
                <a
                  href='https://lili.co/legal-documents/300-promotion-terms-and-conditions'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='underline'>
                  {t('pages.homePasswordless.wyomingValueProposal.welcomeBonusTermsLink')}
                </a>{' '}
                {t('pages.homePasswordless.wyomingValueProposal.welcomeBonusTermsSuffix')}
              </Text.H14>
            </li>
          </ol>
          <Text.H14 fontWeight={FontWeight.SEMIBOLD} className='text-text-main-tertiary-inverse'>
            {t('pages.homePasswordless.valueProposal.USAPatriotNotice')}
          </Text.H14>
          <Text.H14 className='text-text-main-tertiary-inverse'>
            {t('pages.homePasswordless.valueProposal.USAPatriotNoticeContent')}
          </Text.H14>
          <Text.H14 className='text-text-main-tertiary-inverse' id='value-proposal-disclaimer'>
            {t('pages.homePasswordless.valueProposal.disclaimer')}
          </Text.H14>
        </div>
      </div>
    </div>
  );
};

const DesktopAwardsSection = () => {
  return (
    <div className='hidden sm:flex flex-col gap-[16px]'>
      <div className='flex gap-[16px]'>
        <FastestGrowingIcon />
        <BestSmbDigital />
        <BestMobile />
      </div>
      <div className='flex gap-[16px]'>
        <BestSmbBank />
        <BestSmbApp />
        <BestAi />
      </div>
    </div>
  );
};

const MobileAwardsSection = () => {
  return (
    <div className='sm:hidden flex gap-[16px] w-full justify-between'>
      <div className='flex flex-col gap-[32px]'>
        <FastestGrowingIconMobile />
        <BestMobileMobile />
        <BestSmbAppMobile />
      </div>
      <div className='flex flex-col gap-[32px]'>
        <BestSmbDigitalMobile />
        <BestSmbBankMobile />

        <BestAiMobile />
      </div>
    </div>
  );
};
